import { useEffect, useRef, useState } from "react";

export function CommerceDemo() {
  const root = useRef<HTMLDivElement>(null);
  const [phase, setPhase] = useState(2);

  useEffect(() => {
    const element = root.current;
    if (!element || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const timers: number[] = [];
    const play = () => {
      setPhase(0);
      timers.push(window.setTimeout(() => setPhase(1), 650));
      timers.push(window.setTimeout(() => setPhase(2), 1450));
    };
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        play();
        observer.disconnect();
      }
    }, { threshold: 0.35 });
    observer.observe(element);
    return () => {
      observer.disconnect();
      timers.forEach(window.clearTimeout);
    };
  }, []);

  return (
    <div className="commerce-demo" ref={root} aria-label="Sample Shopify conversation commerce demonstration">
      <div className="commerce-demo-head"><span>Shopify connected</span><button type="button" onClick={() => { setPhase(0); window.setTimeout(() => setPhase(2), 720); }}>Replay</button></div>
      <div className="commerce-chat">
        <div className="commerce-user">Do you have the Weekend Carryall in olive?</div>
        {phase === 1 && <div className="commerce-typing" aria-label="Marky is typing"><i /><i /><i /></div>}
        {phase >= 2 && (
          <div className="commerce-reply">
            <div className="commerce-marky"><img src="/brand/marky-solid.svg" alt="" /><span>Yes. The Weekend Carryall is available in olive.</span></div>
            <article className="commerce-product">
              <img src="/portfolio/demo-weekend-carryall.webp" alt="Olive Weekend Carryall sample product" />
              <div><strong>Weekend Carryall</strong><span>Olive canvas, sample product</span><button type="button">Select options</button></div>
            </article>
          </div>
        )}
      </div>
      <div className="commerce-channels"><span>Webchat</span><span>Instagram</span><span>Messenger</span></div>
    </div>
  );
}
